import { Row } from '@unistocks/components/layout/flex';
import { LogoProps } from '@unistocks/components/logo/logo';
import { Header } from '@unistocks/components/navigation/header';
import { LanguageSwitch } from '@unistocks/components/settings/language-switch';
import { ThemeSwitch } from '@unistocks/components/settings/theme-switch';
import { Href } from 'expo-router';
import React from 'react';
import { useMedia } from 'tamagui';

export type HeaderProps = LogoProps & {
  logoHref?: Href;
};

export const AuthHeader: React.FC = () => {
  const media = useMedia();

  return (
    <Header
      renderRight={
        media.sm
          ? () => (
              <Row gap={'$3'} alignItems={'center'}>
                <LanguageSwitch />
                <ThemeSwitch size={'$1.5'} />
              </Row>
            )
          : undefined
      }
    />
  );
};
